module.exports = __webpack_public_path__ + "img/IMG-20191228-WA0029.6ca71759.jpg";